import ContestEntries from 'umg-ember-backend/components/record-explorer/for/contest-entry';

<template>
  <ContestEntries @records={{@model}} @recordType='contest-entry' />
</template>
